import {
  CreateServiceItemDto,
  ServiceItem,
  ServiceItemPaginatedResponse,
  UpdateServiceItemDto,
} from 'types/models';
import apiClient from './apiClient';

export interface ServiceItemQuery {
  page?: number;
  limit?: number;
  status?: string;
  search?: string;
}

export const serviceItemService = {
  list: async (params: ServiceItemQuery = {}): Promise<ServiceItemPaginatedResponse> => {
    const { data } = await apiClient.get<ServiceItemPaginatedResponse>('/catalog/services', { params });
    return data;
  },

  listAll: async (): Promise<ServiceItem[]> => {
    const { data } = await apiClient.get<ServiceItemPaginatedResponse>('/catalog/services', {
      params: { limit: 100, page: 1 },
    });
    return data.data;
  },

  getById: async (id: string): Promise<ServiceItem> => {
    const { data } = await apiClient.get<ServiceItem>(`/catalog/services/${id}`);
    return data;
  },

  create: async (payload: CreateServiceItemDto): Promise<ServiceItem> => {
    const { data } = await apiClient.post<ServiceItem>('/catalog/services', payload);
    return data;
  },

  update: async (id: string, payload: UpdateServiceItemDto): Promise<ServiceItem> => {
    const { data } = await apiClient.patch<ServiceItem>(`/catalog/services/${id}`, payload);
    return data;
  },

  deactivate: async (id: string): Promise<ServiceItem> => {
    const { data } = await apiClient.patch<ServiceItem>(`/catalog/services/${id}/deactivate`);
    return data;
  },

  activate: async (id: string): Promise<ServiceItem> => {
    const { data } = await apiClient.patch<ServiceItem>(`/catalog/services/${id}/activate`);
    return data;
  },
};
